import { render, staticRenderFns } from "./EditTemplateActionButtons.vue?vue&type=template&id=be988bd2"
import script from "./EditTemplateActionButtons.vue?vue&type=script&lang=js"
export * from "./EditTemplateActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports